<template>
    <v-app dark>
        <v-toolbar dense :class="{'scanner-active': scannerActive, 'offline': isOffline}">
            <!--<v-toolbar-side-icon to="/"></v-toolbar-side-icon>-->
            <v-toolbar-title @click="$router.push({name:'home'})">
                {{$vuetify.t('$vuetify.app.name')}}
                <v-icon>how_to_reg</v-icon>
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-badge
                color="red" overlap bottom
                v-if="$store.state.sendQueue.length"
            >
                <span slot="badge">{{$store.state.sendQueue.length}}</span>
                <v-icon>warning</v-icon>
            </v-badge>

            <v-spacer></v-spacer>

            <v-toolbar-items>
                <span class="offline-message" v-if="isOffline">
                    {{$vuetify.t('$vuetify.app.networkNotAvailable')}}
                </span>
                <v-icon color="success" v-if="isOnline">wifi</v-icon>
                <v-icon color="white" v-if="isOffline">wifi_off</v-icon>
                <v-menu bottom left
                        v-if="$store.state.user"
                >
                    <v-btn
                            slot="activator"
                            dark
                            icon
                            small
                    >
                        <v-icon>more_vert</v-icon>
                    </v-btn>

                    <v-list>
                        <v-list-tile @click="startTestScanner">
                            <v-list-tile-title>{{$vuetify.t('$vuetify.menu.test')}}</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click.prevent="showSettings">
                            <v-list-tile-title>{{$vuetify.t('$vuetify.menu.settings')}}</v-list-tile-title>
                        </v-list-tile>
                        <!--<v-list-tile v-if="$store.state.tickets.length">-->
                            <!--<v-list-tile-title>Statistika</v-list-tile-title>-->
                        <!--</v-list-tile>-->
                        <v-divider></v-divider>
                        <v-list-tile
                                href="/admin/"
                                target="_blank"
                        >
                            <v-list-tile-title>{{$vuetify.t('$vuetify.menu.admin')}}</v-list-tile-title>
                        </v-list-tile>
<!--                        <v-list-tile-->
<!--                                @click.prevent="resetTickets"-->
<!--                                color="error"-->
<!--                        >-->
<!--                            {{$vuetify.t('$vuetify.menu.resetTickets')}}-->
<!--                        </v-list-tile>-->
                        <v-list-tile
                                @click.prevent="resetState"
                                color="error"
                        >
                            {{$vuetify.t('$vuetify.menu.resetState')}}
                        </v-list-tile>
                        <v-divider></v-divider>
                        <v-list-tile
                                @click.prevent="logout"
                                v-if="$store.state.user"
                        >
                            {{$vuetify.t('$vuetify.menu.logout')}}
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </v-toolbar-items>
        </v-toolbar>

        <v-content>
            <v-container fluid>
                <router-view :key="$route.fullPath" />
            </v-container>
        </v-content>

        <v-snackbar v-model="showReset" color="success">
            {{$vuetify.t('$vuetify.app.reseted')}}
        </v-snackbar>

        <v-snackbar v-model="$store.state.networkError" color="error">
            {{$vuetify.t('$vuetify.app.networkError')}}
        </v-snackbar>
    </v-app>
</template>

<script>
    import {initSound} from './libs/utils'

    export default {
        data() {
            return {
                showReset: false,
                timer: null
            }
        },

        created() {
            this.$store.dispatch('getUserStatus')

            this.timer = setInterval(() => {
                this.$store.dispatch('sendFromQueue')
            }, 5000)
        },

        computed: {
            scannerActive () {
                return this.$route.fullPath.indexOf('scanner') !== -1
            }
        },

        beforeDestroy () {
            clearInterval(this.timer)
        },

        methods: {
            logout() {
                this.$store.dispatch('logoutUser')
                    .then(() => {
                        this.$router.push({name:'home'})
                    })
            },
            resetTickets() {
                this.$store.state.tickets.forEach(ticketset => {
                    this.$store.dispatch('ticketsReset', ticketset.id)
                })
                this.showReset = true
            },
            resetState() {
                this.$store.commit('reset')
                this.$router.push({name:'home'})
            },

            startTestScanner() {
                initSound(this.$store)
                this.$router.push({name:'test-scanner'})
            },

            showSettings() {
                this.$router.push({name:'settings'})
            }
        }
    }
</script>

<style lang="scss" scoped>
    .scanner-active {
        z-index: 1;
        background-color: rgba(33,33,33,0.33) !important;

        &.offline {
            background-color: rgba(255,0,0, 1) !important;
        }
    }
</style>

<style lang="scss">
    #app.application .primary {
        color: black !important;
    }

    .v-toolbar.offline {
        background-color: red;
    }

    .offline-message {
        color: white;
        font-size: 1.2em;
        padding-top: 10px;
        padding-right: 12px;
        font-weight: bold;
    }
</style>
